/** Qualification is verified when it has supporting docs and every one is verified. */
export function isQualificationEvidenceVerified(
  qualificationId: string,
  documents: { qualification_id?: string; is_verified: boolean }[],
): boolean {
  const evidence = documents.filter(doc => doc.qualification_id === qualificationId);
  return evidence.length > 0 && evidence.every(doc => doc.is_verified);
}

/** Newest completed/issued first; missing issue dates go last. */
export function sortQualificationsByIssueDate<
  T extends { issue_date?: string; created_at?: string },
>(qualifications: T[]): T[] {
  return [...qualifications].sort((a, b) => {
    const aIssue = a.issue_date ? new Date(a.issue_date).getTime() : Number.NEGATIVE_INFINITY;
    const bIssue = b.issue_date ? new Date(b.issue_date).getTime() : Number.NEGATIVE_INFINITY;
    if (bIssue !== aIssue) return bIssue - aIssue;

    const aCreated = a.created_at ? new Date(a.created_at).getTime() : 0;
    const bCreated = b.created_at ? new Date(b.created_at).getTime() : 0;
    return bCreated - aCreated;
  });
}

/** Reference is verified when it has supporting docs and every one is verified. */
export function isReferenceEvidenceVerified(
  referenceId: string,
  documents: { reference_id?: string; is_verified: boolean }[],
): boolean {
  const evidence = documents.filter(doc => doc.reference_id === referenceId);
  return evidence.length > 0 && evidence.every(doc => doc.is_verified);
}

/** Active manager verification request for a qualification (pending or awaiting review). */
export function getActiveQualificationVerification<
  T extends { qualification_id?: string; status: string },
>(qualificationId: string, verifications: T[]): T | undefined {
  return verifications.find(
    ver =>
      ver.qualification_id === qualificationId &&
      (ver.status === 'pending' || ver.status === 'responded'),
  );
}
